import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('fullWidthVideo', (props: any) => ({
    ...props,
    iframeVideoTypes: ['youtube', 'vimeo'],
    hasCoverImage: props.hasCoverImage !== false,
    showCoverImage: props.hasCoverImage !== false,

    init() {
      this.$nextTick(() => {
        const vt = this.videoType as string | undefined;
        const vc = this.videoCode as string | undefined;
        if (!vt || !this.iframeVideoTypes.includes(vt)) {
          return;
        }
        if (this.hasCoverImage) {
          return;
        }
        const iframe = this.$refs.iframe as HTMLIFrameElement | undefined;
        if (!iframe || vc == null || vc === '') {
          return;
        }
        const preview = previewIframeUrl(vt, String(vc));
        if (preview) {
          iframe.setAttribute('src', preview);
        }
        this.showCoverImage = false;
      });
    },

    playVideo() {
      this.showCoverImage = false;
      if (this.iframeVideoTypes.includes(this.videoType)) {
        const iframe = this.$refs.iframe as HTMLIFrameElement | undefined;
        iframe?.setAttribute('src', autoplayIframeUrl(this.videoType, String(this.videoCode)));
      } else {
        const player = this.$refs.player as HTMLVideoElement | undefined;
        player?.play();
      }
    },

    getUrl() {
      return autoplayIframeUrl(String(this.videoType), String(this.videoCode));
    },
  }));
};

function autoplayIframeUrl(videoType: string, videoCode: string): string {
  switch (videoType) {
    case 'youtube':
      return `https://www.youtube.com/embed/${videoCode}?autoplay=1`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${videoCode}?autoplay=1`;
    default:
      return '';
  }
}

function previewIframeUrl(videoType: string, videoCode: string): string {
  switch (videoType) {
    case 'youtube':
      return `https://www.youtube.com/embed/${videoCode}?rel=0`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${videoCode}`;
    default:
      return '';
  }
}
